import styled from "styled-components";

export const Switch = styled.label`
  position: relative;
  width: 72px;
    display: inline-block;

  height: 36px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + .slider {
      /* background-color: #7f3da5; */
    }
    &:focus + .slider {
      box-shadow: 0 0 1px #7f3da5;
    }
    &:checked + .slider:before {
      -webkit-transform: translateX(36px);
      -ms-transform: translateX(36px);
      transform: translateX(36px);
      background-color: #f9b608;
    }
  }
`;
export const Slider = styled.div`
  border: 3px solid #f9b608;
  box-sizing: content-box;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  &::before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    border-radius: 34px;
    left: 2px;
    bottom: 2px;
    border: 3px solid #f9b608;
    background-color: transparent;
    -webkit-transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`;
